import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');

        if (!email || !password) {
            setError('Both email and password are required');
            return;
        }

        try {
            const response = await axios.post('https://qrapi.emedha.in/api/auth/login', { email, password }, { headers: { 'Content-Type': 'application/json' } });


            if (response.status === 200) {
                alert('Login successful');
                const { user } = response.data;

                // Save user data in sessionStorage
                sessionStorage.setItem('userId', user.id);
                sessionStorage.setItem('userEmail', user.email);
                localStorage.setItem('token', response.data.token); // Store token if provided
                navigate('/dashboard'); // Redirect to Dashboard
            }
        } catch (err) {
            setError(err.response?.data?.error || 'Login failed');
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center vh-100">
            <div className="card p-4 shadow-sm" style={{ width: '400px' }}>
                <h2 className="text-center mb-4">Login</h2>
                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <label className="form-label">Email:</label>
                        <input
                            type="email"
                            className="form-control"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Password:</label>
                        <input
                            type="password"
                            className="form-control"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            required
                        />
                    </div>
                    {error && <div className="alert alert-danger text-center">{error}</div>}
                    <button type="submit" className="btn btn-primary w-100">Login</button>
                </form>
                <p className="text-center mt-3">
                    Don’t have an account? <a href="/sign" className="text-decoration-none">Signup here</a>
                </p>
            </div>
        </div>
    );
};

export default Login;
